import axios from "axios";
import { API_BASE_URL } from "../../config";
import { authHeaders } from "../utils/session";

/**
 * Global email templates — the system-wide ones (subscription, auth, wallet …),
 * not the lead / customer templates the Template Manager handles.
 *
 * These are superadmin-only: the normal update endpoint answers 422 for a
 * template whose context is not lead/customer, which is exactly why this flow
 * has its own screen and its own save endpoint.
 */

const jsonHeaders = () => ({
  ...authHeaders(),
});

/** Pull the API's own reason out of an axios failure (403 / 422 land here). */
const apiError = (err, fallback) => {
  const data = err?.response?.data;
  return new Error(data?.message || data?.error || err?.message || fallback);
};

export const fetchGlobalTemplates = async (params = {}) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/get-global-email-template-list`, {
      params,
      headers: jsonHeaders(),
    });
    const payload = res.data || {};
    const list = Array.isArray(payload.data) ? payload.data : Array.isArray(payload) ? payload : [];
    return list;
  } catch (err) {
    throw apiError(err, "Failed to load global templates");
  }
};

/** Shared with the normal template editor — the detail endpoint is the same. */
export const fetchTemplateDetails = async (id) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/get-email-template-details/${id}`, {
      headers: jsonHeaders(),
    });
    if (res.data?.status && res.data.data) return res.data.data;
    throw new Error(res.data?.message || "Template not found");
  } catch (err) {
    throw apiError(err, "Failed to load template");
  }
};

/** Superadmin-only save. A non-superadmin token gets 403 from the API. */
export const updateGlobalTemplate = async (id, payload) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/update-global-email-template-details/${id}`,
      payload,
      { headers: jsonHeaders() },
    );
    const data = res.data || {};
    if (data.status === false) throw new Error(data.message || "Failed to update template");
    return data;
  } catch (err) {
    throw apiError(err, "Failed to update template");
  }
};
